import React from "react";
import TelegramChat from "./components/TelegramChat";

function App() {
  return <TelegramChat />;
}

export default App;
